import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'dashboard_epargn.situation_date_title',
  },
});
